import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { HaloToastService } from 'src/app/core/halo-toast/halo-toast.service';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { ToastMessageService } from 'src/app/core/shared-service/toast-message.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { InviteFacilityModel, RequestInviteFacilityModel, ResponseInviteFacilityModel } from 'src/app/post-login/services/multi-facility.model';
import { MultiFacilityService } from 'src/app/post-login/services/multi-facility.service';
import { HaloTipsService } from 'src/app/core/halo-tips/halo-tips.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Component({
  selector: 'app-invite-facility',
  templateUrl: './invite-facility.component.html',
  styleUrls: ['./invite-facility.component.scss'],
})
export class InviteFacilityComponent implements OnInit {
  private _rootScopeData: RootScopeDeclare;
  private _rootScopeDataSubscription: Subscription;
  private _defaultInputRows: number = 5;

  isMobile = false;
  inviteFacilityList: InviteFacilityModel[] = [];
  disableSubmitButton: string = 'true';

  constructor(
    private _rootScopeService: RootScopeService,
    private _router: Router,
    private _mService: MultiFacilityService,
    private _loader: HaloLoaderService,
    private _toast: HaloToastService,
    private _util: CommonUtil,
    private _haloTips: HaloTipsService,
    private _amplitudeAnalytics: AmplitudeAnalyticsService
  ) {}

  ngOnInit(): void {
    this.getRootScopeData();

    // add default 5 rows
    this.initForm();

    // this._haloTips.show();
  }

  initForm() {
    this.inviteFacilityList = [];
    for (let i = 0; i < this._defaultInputRows; i++) {
      this.inviteFacilityList.push(new InviteFacilityModel('', ''))
    }
  }

  ngOnDestroy() {
    this._rootScopeDataSubscription.unsubscribe();
  }

  onAddMoreFacility() {
    this.inviteFacilityList.push(new InviteFacilityModel('', '', [], []));
  }

  onSubmit() {
    let payload: RequestInviteFacilityModel = new RequestInviteFacilityModel([]);
    this.inviteFacilityList.forEach((i) => {
      if (i.email && i.requestedFacilityId) {
        payload.inviteFacilityVOList.push(new InviteFacilityModel(i.email, i.requestedFacilityId));
      }
      // clear errors
      i.emailErrorCodes = [];
      i.facilityErrorCodes = [];
    });

    if (payload.inviteFacilityVOList.length > 0) {
      this._loader.startProcess();      
      this._amplitudeAnalytics.logEvent({elementName: 'Submit', action: 'Submit'});
      const inviteFacility = this._mService.inviteFacilityByEmail(payload).subscribe(
        (res: any) => {
          if (res.facilityInviteSuccessCount === '1') {
            this._toast.creatToast(this._util.translateText('INVITE.FACILITY.SUCCESS.MSG.SINGULAR'));
          } else {
            this._toast.creatToast(this._util.translateText('INVITE.FACILITY.SUCCESS.MSG.PLURAL'));

          }
          this.initForm();
          this._loader.endProcess();
          this._rootScopeData.isPageHasUnsavedChanges = false;
          this._router.navigate(['/facility/manage/pending-request']);
        },
        (err) => {
          let error = err.error as ResponseInviteFacilityModel;
          if (error?.invalidParams?.length) {

            error.invalidParams.forEach(iParam => {
              if(!iParam.facilityErrorCodes) iParam.facilityErrorCodes = [];
              if(!iParam.emailErrorCodes) iParam.emailErrorCodes = [];
              iParam.facilityErrorCodes?.forEach(eCode => {
                if (eCode.includes('invite_facility_request_exists_with')) {
                  let _dynamicErrorCode = eCode.split(':');
                  iParam.facilityErrorCodes!.push(_dynamicErrorCode[0]);
                  iParam.inviteFacilityRequestExistsWith = _dynamicErrorCode[1];
                }
                if(eCode.includes('approver_not_admin')) {
                  iParam.emailErrorCodes!.push('approver_not_admin');
                }
                if(eCode.includes('entity_exists')) {
                  iParam.emailErrorCodes!.push('entity_exists');
                }
              })
            });


            this.inviteFacilityList = error.invalidParams!;
          }
          this._loader.endProcess();
        }
      );
      this._rootScopeDataSubscription.add(inviteFacility);
    }
  }

  onCancel() {
    if(this._rootScopeData.isPageHasUnsavedChanges) {
      this._rootScopeData.pathToNavigate = '/facility/manage'
      this._rootScopeData.showUnSavedChangesModal = true;
    } else {
      this._router.navigate(['/facility/manage']);
    }
  }

  getRootScopeData(): void {
    this._rootScopeDataSubscription = this._rootScopeService.getRootScope().subscribe((rootScopeData) => {
      this._rootScopeData = rootScopeData;
      this.isMobile = rootScopeData.deviceType === 'phone';
    });
  }

  onKeyupValidate(data: InviteFacilityModel): void {
    this._rootScopeData.isPageHasUnsavedChanges = true;

    if(data) {
      // facility only number
      data.requestedFacilityId = data.requestedFacilityId.replace(/[^0-9]/g, '');

      if(!data.facilityErrorCodes) data.facilityErrorCodes = [];
      if(!data.emailErrorCodes) data.emailErrorCodes = [];
      this.disableSubmitButton = this.inviteFacilityList.filter(inv => inv.email && inv.requestedFacilityId)?.length == 0 ? 'true' : 'false';
      if ((data.email && !data.requestedFacilityId) || (!data.email && data.requestedFacilityId)) {
        this.disableSubmitButton = 'true';
      }

      let facFound = this.inviteFacilityList.filter(inv => data.requestedFacilityId && inv.requestedFacilityId == data.requestedFacilityId);
      if(facFound?.length > 1) {
        this.disableSubmitButton = 'true';
        if(!data.facilityErrorCodes.includes('entity_exists')) data.facilityErrorCodes.push('entity_exists');
      } else if(data.facilityErrorCodes?.includes('entity_exists')){
        data.facilityErrorCodes.splice(data.facilityErrorCodes.indexOf('entity_exists'), 1);
      }

      if(data.email === this._rootScopeData.currentUser.emailAddress) {
        if(!data.emailErrorCodes.includes('invited_own_email')) data.emailErrorCodes.push('invited_own_email');
        if(data.requestedFacilityId && !data.facilityErrorCodes.includes('invited_own_email')) data.facilityErrorCodes.push('invited_own_email');
        this.disableSubmitButton = 'true';
      } else {
        if(data.emailErrorCodes.includes('invited_own_email'))
        data.emailErrorCodes.splice(data.emailErrorCodes.indexOf('invited_own_email'), 1);
        if(data.facilityErrorCodes.includes('invited_own_email'))
        data.facilityErrorCodes.splice(data.facilityErrorCodes.indexOf('invited_own_email'), 1);
      }

      // email validate
      if (data.email && !this._util.isEmail(data.email)) {
        if (data.emailErrorCodes.indexOf('invalid_email_format') < 0) {
          data.emailErrorCodes?.push('invalid_email_format');
        }
      } else if(data.emailErrorCodes.includes('invalid_email_format')){
        data.emailErrorCodes.splice(data.emailErrorCodes.indexOf('invalid_email_format'), 1);
      }
    }
  }
}
